import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  MASTER_SYSTEM_SERVER_LIST,
  MASTER_SYSTEM_SERVER_DEPLOY,
} from "./actionType";

import {
  masterSystemServerListSuccess,
  masterSystemServerListFailure,
  masterSystemServerDeploySuccess,
  masterSystemServerDeployFailure,
} from "./action";

import {
  getMasterSystemServerList,
  deployMasterSystemServer,
} from "../../helpers/fakebackend_helper";

// LIST
function* fetchMasterSystemServerList() {
  try {
    const response = yield call(getMasterSystemServerList);
    yield put(masterSystemServerListSuccess(response));
  } catch (error) {
    yield put(masterSystemServerListFailure(error));
  }
}
function* watchFetchMasterSystemServerList() {
  yield takeEvery(MASTER_SYSTEM_SERVER_LIST, fetchMasterSystemServerList);
}

// DEPLOY
function* deployMasterSystemServerSaga(action) {
  try {
    const response = yield call(deployMasterSystemServer, action.payload);
    yield put(masterSystemServerDeploySuccess(response));
  } catch (error) {
    yield put(masterSystemServerDeployFailure(error));
  }
}
function* watchDeployMasterSystemServer() {
  yield takeEvery(MASTER_SYSTEM_SERVER_DEPLOY, deployMasterSystemServerSaga);
}

export default function* masterSystemServerSaga() {
  yield all([
    fork(watchFetchMasterSystemServerList),
    fork(watchDeployMasterSystemServer),
  ]);
}
